







































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import VoteButton from '@/components/VoteButton.vue';
import { getVoteList } from '@/api/api.ts';
import eventBus from '../Bus';
Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button);
@Component({
  components: {
    VoteButton,
  },
})
export default class VoteList extends Vue {
  @Prop() listType!: any;
  @Prop() options!: any;
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  result: any[] = [];
  SearchData = '';
  // 初使加载
  mounted() {
    getVoteList({
      voteName: this.options.voteName,
    }).then((res: any) => this.fetchListData(res));
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 200) {
      this.getListData = res.data;
    }
  }
  // 进入详情页
  enterDetailPage(item: any) {
    // console.log(this.$routerThen);
    this.$routerThen
      .push({
        url: `./Detail?id=${item.id}`,
      })
      .then((vm) => {
        vm.$on('vote', (val: any) => {
          console.log('%c已点赞, 回传值为: ', 'color: coral', val);
          if (this.result.length === 10) {
            return;
          }
          if (this.result.includes(val)) {
            return;
          } else {
            this.result.push(val);
          }
        });
      });
    // this.$router.push({ path: './Detail', query: { id: item.id } });
    // this.$emit('enterDetailPage', item.id);
  }
  // 多选
  chooseOpus() {
    this.$emit('choose', this.result);
  }
}
